import { useScopedTranslation } from '@lmt/unicorn-shared/app/helpers/localization/useScopedTranslation';
import React from 'react';
import { getFontColor } from '../../color-settings/components/color-parser';
import { getFormattedTimeRange } from '@lmt/unicorn-shared/app/components/patients/common';
import { VisitCardLineStyleDto, WaitingListPriority } from '@lmt/shared-types';
import { AppointmentPatientInfo } from './types';

import styles from './VisitContent.module.scss';
import VisitCard from '../../visit-card-settings/components/VisitCard';
export type VisitContentProps = {
  data: {
    data?: {
      start: Date;
      end: Date;
      expressions?: string[];
    };
    patient?: AppointmentPatientInfo;
    color: string;
    title: string;
    subtenantCode: string;
    priority?: number | null;
    priorityContact?: string | null;
    id: number | string;
    lineStyles: VisitCardLineStyleDto[];
  };
};
export const VisitContent: React.FC<VisitContentProps> = React.memo(
  function VisitContent(props) {
    const i18n = useScopedTranslation('calendar.priority');
    if (
      props.data.lineStyles.length > 0 &&
      props.data.data?.expressions?.length === props.data.lineStyles.length
    ) {
      return (
        <VisitCard
          color={props.data.color}
          appointmentId={props.data.id}
          content={props.data.lineStyles.map((lineStyle) => {
            const value =
              props.data?.data?.expressions?.[lineStyle.position] ?? '';
            const style = {
              fontSize: `${lineStyle.fontSize}px`,
              paddingTop: `${lineStyle.paddingTop}px`,
              fontWeight: lineStyle.isBold ? 'bold' : 'normal',
            };
            return {
              value,
              style,
            };
          })}
        />
      );
    }

    return (
      <div
        data-test-id={'calendar-appointment'}
        data-appointment-id={props.data.id}
        style={{
          color: getFontColor(props.data.color),
          backgroundColor: props.data.color,
          borderLeftColor: getFontColor(props.data.color),
        }}
        className={styles.container}
      >
        {props.data.data && (
          <div className={styles.timeRange} data-test-id="time-range">
            {getFormattedTimeRange(props.data.data.start, props.data.data.end)}
          </div>
        )}
        {props.data.priority && (
          <div className={styles.priority}>
            {i18n.t('title') +
              ' ' +
              i18n.t(
                WaitingListPriority[props.data.priority].toLowerCase() as any,
              )}
          </div>
        )}
        <div className={styles.patient} data-test-id="patient">
          {props.data.patient?.fullName}
          <span className={styles.code}>{props.data.subtenantCode}</span>
        </div>
        {props.data.priorityContact && (
          <div
            className={styles.priorityContact}
            data-test-id="priority-contact"
          >
            {props.data.priorityContact}
          </div>
        )}
        <div className={styles.title} data-test-id="title">
          {props.data.title}
        </div>
      </div>
    );
  },
);
